// Correct Zone or Not
(() => {
  const parseZone = (raw) => {
    if (raw == null) return NaN;
    const n = Number(String(raw).trim());
    return Number.isFinite(n) ? n : NaN;
  };

  const within = (val, low, high) => {
    if (![val, low, high].every(Number.isFinite)) return false;
    const lo = Math.min(low, high);
    const hi = Math.max(low, high);
    return val >= lo && val <= hi;
  };

  const show = (el) => el && el.removeAttribute('hidden');
  const hide = (el) => el && el.setAttribute('hidden', '');

  let intervalId = null;

  const evaluateAll = () => {
    const containers = document.querySelectorAll('[data-lowest-growing-zone][data-highest-growing-zone]');
    containers.forEach((container) => {
      const lowest = parseZone(container.getAttribute('data-lowest-growing-zone'));
      const highest = parseZone(container.getAttribute('data-highest-growing-zone'));

      // Shopper zone comes from the element's textContent
      const zoneEl = document.querySelector('[data-product-info-growing-zone]');
      const shopperZone = parseZone(zoneEl ? zoneEl.textContent : null);

      const correct = document.querySelector('[data-correct-growing-zone]');
      const notCorrect = document.querySelector('[data-not-correct-growing-zone]');

      if(zoneEl.textContent == '') {
        hide(notCorrect);
        hide(correct);
        return
      }

      const isOk = within(shopperZone, lowest, highest);
      if (isOk) { show(correct); hide(notCorrect); } else { show(notCorrect); hide(correct); }
    });
  };

  const start = () => {
    if (intervalId) return;
    evaluateAll();
    intervalId = setInterval(evaluateAll, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.GrowingZoneToggler = {
    refresh: evaluateAll,
    stop: () => { if (intervalId) { clearInterval(intervalId); intervalId = null; } },
    start
  };
})();

// Fly to ATC (PDP: gallery image in same product-info; quick-add: data-quick-add-fly-image)
document.addEventListener('click', e => {
  const btn = e.target.closest('.product-form__submit')
  if (!btn) return
  const productInfo = btn.closest('product-info')
  if (!productInfo) return
  const cart = document.querySelector('.cart-drawer-button')
  if (!cart) return

  const galleryImgs = productInfo.querySelectorAll('.product__media-item img')
  let sourceImg = null
  if (galleryImgs.length) {
    sourceImg = galleryImgs[galleryImgs.length - 1]
  } else {
    sourceImg = productInfo.querySelector('[data-quick-add-fly-image]')
  }
  if (!sourceImg || !(sourceImg.currentSrc || sourceImg.src)) return
  flyToCartCurved(sourceImg, btn, cart)
})

function flyToCartCurved(sourceImg, btn, cart) {
  const b = btn.getBoundingClientRect()
  const t = cart.getBoundingClientRect()
  const size = 48
  const startX = b.left + b.width / 2 - size / 2
  const startY = b.top + b.height / 2 - size / 2
  const endX = t.left + t.width / 2 - size / 2
  const endY = t.top + t.height / 2 - size / 2

  const wrap = document.createElement('div')
  wrap.className = 'fly-clone'
  wrap.style.width = size + 'px'
  wrap.style.height = size + 'px'
  wrap.style.left = 0
  wrap.style.top = 0
  wrap.style.transform = `translate(${startX}px, ${startY}px)`
  const img = document.createElement('img')
  img.src = sourceImg.currentSrc || sourceImg.src
  img.alt = ''
  img.style.width = '100%'
  img.style.height = '100%'
  img.style.objectFit = 'cover'
  wrap.appendChild(img)
  document.body.appendChild(wrap)

  const keyframes = []
  const steps = 50
  const curveHeight = 120
  const wiggle = 60 // horizontal swing in px

  for (let i = 0; i <= steps; i++) {
    const tVal = i / steps

    // quadratic curve Y
    const midX = (startX + endX) / 2
    const midY = Math.min(startY, endY) - curveHeight
    const xCurve = (1 - tVal) ** 2 * startX + 2 * (1 - tVal) * tVal * midX + tVal ** 2 * endX
    const yCurve = (1 - tVal) ** 2 * startY + 2 * (1 - tVal) * tVal * midY + tVal ** 2 * endY

    // wiggle sideways (sin wave) → goes left & right
    const xOffset = Math.sin(tVal * Math.PI * 2) * wiggle * (1 - tVal) // dampens toward end
    const x = xCurve + xOffset
    const y = yCurve

    const scale = 1 - tVal * 0.9
    keyframes.push({ transform: `translate(${x}px, ${y}px) scale(${scale})`, opacity: 1 - tVal * 0.5 })
  }

  const anim = wrap.animate(keyframes, { duration: 1400, easing: 'linear', fill: 'forwards' })

  anim.onfinish = () => {
    wrap.remove()
    cart.classList.add('cart-bump')
    setTimeout(() => cart.classList.remove('cart-bump'), 360)
  }
}

// High Yield
document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('button[data-high-yield-product]')
  const popup = document.querySelector('[data-high-yield-popup]')
  const closeEls = popup ? popup.querySelectorAll('[data-hy-close]') : []
  const addOneMoreBtn = popup ? popup.querySelector('.hy-cta') : null
  const keepOneBtn = popup ? popup.querySelector('.hy-cta-no') : null

  function getQtyInput() {
    if (!addToCartBtn) return null
    const form = addToCartBtn.closest('form')
    if (!form) return document.querySelector('input[name="quantity"]')
    return form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]')
  }

  if (addToCartBtn && popup) {
    addToCartBtn.addEventListener('click', function (event) {
      if (addToCartBtn.dataset.bypassUpsell === '1') {
        delete addToCartBtn.dataset.bypassUpsell
        return
      }
      const qtyInput = getQtyInput()
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      if (!addToCartBtn.disabled && qty === 1) {
        event.preventDefault()
        popup.classList.add('is-open')
      }
    })
  }

  function proceedWithQty(qty) {
    const qtyInput = getQtyInput()
    if (qtyInput) {
      qtyInput.value = qty
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
    popup.classList.remove('is-open')
    addToCartBtn.dataset.bypassUpsell = '1'
    addToCartBtn.click()
  }

  if (addOneMoreBtn) {
    addOneMoreBtn.addEventListener('click', function () {
      proceedWithQty(2)
    })
  }

  if (keepOneBtn) {
    keepOneBtn.addEventListener('click', function () {
      proceedWithQty(1)
    })
  }

  closeEls.forEach(el => {
    el.addEventListener('click', function () {
      popup.classList.remove('is-open')
    })
  })
})

// Seasonal shipping: event delegation so quick-view / dynamically loaded product forms work
;(function () {
  function getPopup() {
    return document.querySelector('[data-seasonal-shipping-popup]');
  }

  function hidePopup(popup) {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('hidden', 'true');
    popup.setAttribute('aria-hidden', 'true');
    popup._pendingSeasonalAtcButton = null;
  }

  function applyDateToDescription(popup, formattedDate) {
    const desc = popup.querySelector('#ss-desc');
    if (!desc) return;
    if (!popup.dataset.ssDescTemplate) {
      popup.dataset.ssDescTemplate = desc.innerHTML;
    }
    const tpl = popup.dataset.ssDescTemplate;
    const safe = formattedDate || '—'
    desc.innerHTML = tpl.replace(/\[date\]/gi, safe)
  }

  document.addEventListener(
    'click',
    function (event) {
      const btn = event.target.closest('button[data-seasonal-shipping-product]');
      if (!btn || btn.type !== 'submit' || btn.disabled) return
      if (btn.dataset.bypassShippingPopup === '1') return

      const popup = getPopup()
      if (!popup) return

      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      applyDateToDescription(popup, btn.dataset.shippingDateFormatted || '')
      popup._pendingSeasonalAtcButton = btn
      popup.classList.add('is-open')
      popup.removeAttribute('hidden')
      popup.setAttribute('aria-hidden', 'false')
    },
    true
  )

  document.addEventListener('click', function (event) {
    const confirm = event.target.closest('[data-seasonal-shipping-popup] .ss-cta')
    if (!confirm) return
    const popup = confirm.closest('[data-seasonal-shipping-popup]')
    if (!popup) return

    event.preventDefault()
    const pending = popup._pendingSeasonalAtcButton
    hidePopup(popup)
    if (pending) {
      pending.dataset.bypassShippingPopup = '1'
      pending.click()
      setTimeout(function () {
        delete pending.dataset.bypassShippingPopup
      }, 1000)
    }
  })

  document.addEventListener('click', function (event) {
    const closer = event.target.closest('[data-ss-close]')
    if (!closer) return
    const popup = closer.closest('[data-seasonal-shipping-popup]')
    if (!popup) return
    hidePopup(popup)
  })
})()


// Header Modal Helper functionalities
function HeaderModalsOpen(selector, modalSelector) {
  const wrapper = document.querySelector(selector)
  // wrapper is gone when the simplified header is on
  if (!wrapper) return
  const modal = wrapper.querySelector(modalSelector)

  let isHovering = false
  
  function showModal() {
    modal.style.opacity = '1'
    modal.style.pointerEvents = 'auto'
  }
  
  function hideModal() {
    modal.style.opacity = '0'
    modal.style.pointerEvents = 'none'
  }
  
  wrapper.addEventListener('mouseenter', () => {
    isHovering = true
    showModal()
  })
  
  wrapper.addEventListener('mouseleave', () => {
    isHovering = false
    setTimeout(() => {
      if (!isHovering) hideModal()
    }, 100)
  })
  
  modal.addEventListener('mouseenter', () => {
    isHovering = true
    showModal()
  })
  
  modal.addEventListener('mouseleave', () => {
    isHovering = false
    setTimeout(() => {
      if (!isHovering) hideModal()
    }, 100)
  })
  
  // Optional: initial hidden styles
  modal.style.opacity = '0'
  modal.style.pointerEvents = 'none'
  modal.style.transition = 'opacity 0.3s ease'
  
  if(modalSelector == '.modal-grow-zone') {
    document.querySelectorAll('[data-zone-not-exists]').forEach(el => {
      el.addEventListener('click', () => {
        modal.style.opacity = '1'
        modal.style.pointerEvents = 'auto'
      })
    })
  }
  
  document.addEventListener('click', e => {
    const modalWrapper = document.querySelector(selector)
    const modal = modalWrapper.querySelector(modalSelector)
  
    const isClickInside = modal.contains(e.target) ||
                      e.target.closest('[data-zone-not-exists]') ||
                      e.target.closest('[data-open-grow-zone-drawer]') ||
                      e.target.closest('[data-open-help-modal]')
  
    if (!isClickInside) {
      modal.style.opacity = '0'
      modal.style.pointerEvents = 'none'
    }
  })
}
HeaderModalsOpen('.helper-modal-wrapper-grow-zone', '.modal-grow-zone')
HeaderModalsOpen('.helper-modal-wrapper-inline-help', '.modal-inline-help')

// Growing Zone Modal
function ToggleZoneSwitcher () {
  const currentZone = localStorage.getItem('HHUserCurrentZone')

  if (!currentZone) return

  const zoneTextEls = document.querySelectorAll('[data-text-under]')
  zoneTextEls.forEach(el => {
    el.textContent = `Zone: ${currentZone}`
    el.classList.add('found')
  })

  const noZoneEls = document.querySelectorAll('[data-no-growing-zone]')
  noZoneEls.forEach(el => {
    el.style.display = 'none'
  })

  const yesZoneEls = document.querySelectorAll('[data-yes-growing-zone]')
  yesZoneEls.forEach(el => {
    const link = el.querySelector('.goToGrowingZone')
    const number = el.querySelector('[data-zone-number]')
    el.style.display = 'inline-block'
    if(number)
    {
      number.innerHTML = `${currentZone}`
    }

    if (link) {
      if(!link.classList.contains('not')) {
        link.innerHTML = `<span>Shop Zone ${currentZone}</span>`
      }
      link.href = `/collections/growing-zone-${currentZone}`
      link.classList.add(`zone-${currentZone}`)
    }
  })

  setTimeout(() => {
    const el = document.querySelector(`[data-zone="${currentZone}"]`)
    if (el) {
      const event = new MouseEvent('mouseenter', {
        bubbles: true,
        cancelable: true,
        view: window
      })
      el.dispatchEvent(event)
    }
  }, 200)
}

ToggleZoneSwitcher()


const showGrowingError = msg => {
  const errorEl = document.getElementById('GrowingZoneError')
  if (errorEl) {
    errorEl.textContent = msg
    errorEl.style.display = 'block'
  }
}

document.querySelector('.modal-grow-zone-text-btns .btn').addEventListener('click', () => {
  if (!navigator.geolocation) return alert('Geolocation is not supported by your browser')

  navigator.geolocation.getCurrentPosition(async position => {
    const { latitude, longitude } = position.coords

    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`)
      const data = await res.json()

      const zip = data?.address?.postcode
      const country = data?.address?.country_code
      
      if (!zip || !/^\d{5}(-\d{4})?$/.test(zip)) {
        return showError('Could not retrieve a valid US ZIP code from your location')
      }

      if (country !== 'us') {
        return showError('Only US ZIP codes are supported')
      }
      
      if (zip) {
        document.querySelector('.modal-grow-zone-text-input').value = zip
        document.getElementById('GrowingZoneError').style.display = 'none'

        if (typeof window.calcAndShowDates === 'function') {
          window.calcAndShowDates(zip);
        }
      }
    } catch (e) {
      showGrowingError('Error retrieving ZIP code')
    }
  }, () => {
    showGrowingError('Permission to access location was denied')
  })
})

document.querySelector('.modal-grow-zone-text-btns .btn--primary').addEventListener('click', () => {
  const zip = document.querySelector('.modal-grow-zone-text-input').value.trim()
  
  if (!zip) {
    return showGrowingError('Please enter a ZIP code')
  }
  if (!/^\d{5}(-\d{4})?$/.test(zip)) {
    return showGrowingError('Please enter a valid US ZIP code')
  }
  
  document.getElementById('GrowingZoneError').style.display = 'none'
  localStorage.setItem('HHUserZipCode', zip)
  if (typeof window.calcAndShowDates === 'function') {
    window.calcAndShowDates(zip);
  }

  fetch(`https://api.bowersolutions.ai/hh/getGrowingZones?zip=${zip}`)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok')
      return response.json()
    })
    .then(data => {
      const fullZone = data.row.zone
      const numericZone = /[a-zA-Z]$/.test(fullZone) ? fullZone.slice(0, -1) : fullZone
      localStorage.setItem('HHUserCurrentZone', numericZone)
      ToggleZoneSwitcher()
    })
    .catch(error => {
      showGrowingError('Could not find growing zone for this ZIP code')
    })
})

document.querySelector('[data-new-zip-code]').addEventListener('click', () => {
  localStorage.removeItem('HHUserZipCode')
  localStorage.removeItem('HHUserCurrentZone')

  const zoneTextEl = document.querySelector('[data-text-under]')
  const noZoneEl = document.querySelector('[data-no-growing-zone]')
  const yesZoneEl = document.querySelector('[data-yes-growing-zone]')
  const inputEl = document.querySelector('.modal-grow-zone-text-input')
  const errorEl = document.getElementById('GrowingZoneError')

  if (zoneTextEl) {
    zoneTextEl.textContent = ''
    zoneTextEl.classList.remove('found')
  }

  if (yesZoneEl) yesZoneEl.style.display = 'none'
  if (noZoneEl) noZoneEl.style.display = 'block'
  if (inputEl) inputEl.value = ''
  if (errorEl) errorEl.style.display = 'none'
})

// Growing Zone Modal END

//  ATC Product Card
document.addEventListener('click', async e => {
  const el = e.target.closest('.product_card_atc')
  if (!el) return
  if (el.hasAttribute('aria-controls')) return

  const variantId = el.getAttribute('data-variant-atc-id')
  const redirectUrl = el.getAttribute('data-variant-atc-url')

  if (variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _quick_add: "icon" }
      })
    })

    document.querySelector('.cart-drawer-button')?.click()
    document.dispatchEvent(new CustomEvent('cart:updated'))
    document.dispatchEvent(new CustomEvent('cart:refresh'))
  } else if (redirectUrl) {
    window.location.href = redirectUrl
  }
})
// ATC Product Card END

// General
if(document.querySelector('[data-scroll-to-description]')) {
  document.querySelector('[data-scroll-to-description]').addEventListener("click", () => {
    const target = document.querySelector('.product_additional_info_wrapper')
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 1024) return

  const elements = Array.from(document.querySelectorAll('[data-mousemove]'))

  let targetX = 0
  let targetY = 0
  let currentX = 0
  let currentY = 0

  const lerp = (start, end, amt) => start + (end - start) * amt

  const animate = () => {
    currentX = lerp(currentX, targetX, 0.05)
    currentY = lerp(currentY, targetY, 0.05)

    elements.forEach(el => {
      const moveType = el.getAttribute('data-mousemove')
      const isInverted = el.hasAttribute('data-invert')

      const x = isInverted ? -currentX : currentX
      const y = isInverted ? -currentY : currentY

      if (moveType === 'true') {
        el.style.transform = `translate(${x}px, ${y}px)`
      } else if (moveType === 'false') {
        const rotateX = y * 2.5
        const rotateY = -x * 2.5
        el.style.transform = `translate(${x}px, ${y}px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
        el.style.transformStyle = 'preserve-3d'
        el.style.backfaceVisibility = 'hidden'
      }
    })

    requestAnimationFrame(animate)
  }

  document.addEventListener('mousemove', e => {
    const x = e.clientX / window.innerWidth
    const y = e.clientY / window.innerHeight

    targetX = (0.5 - x) * 20
    targetY = Math.max((1 - y) * 20, 0)
  })

  animate()
})